export const environment = {
    production: false,
    apiUrl: '/api',
    GOOGLE_API_KEY: 'AIzaSyDwjhsjo_KOsMSHpW4bci4UcLw5DjIY-I4'
};


export const adminEnvironment = {
    production: false,
    apiUrl: '/api/admin',
    GOOGLE_API_KEY: 'AIzaSyDwjhsjo_KOsMSHpW4bci4UcLw5DjIY-I4'
}
